var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInputPwIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9541 3C14.7153 3.00026 16.9531 5.23876 16.9531 8V9H17.5C18.6045 9 19.4999 9.97674 19.5 11.1816V18.8184C19.4999 20.0233 18.6045 21 17.5 21H6.5C5.39548 21 4.50009 20.0233 4.5 18.8184V11.1816C4.50009 9.97674 5.39548 9 6.5 9H6.9541V8C6.9541 5.23875 9.19291 3.00024 11.9541 3ZM12 12C10.8956 12 10.0002 12.8956 10 14C10 14.74 10.4026 15.3846 11 15.7305V17C11 17.5523 11.4477 18 12 18C12.5521 17.9998 13 17.5521 13 17V15.7305C13.5971 15.3845 14 14.7397 14 14C13.9998 12.8958 13.1042 12.0002 12 12ZM11.9541 5C10.2975 5.00024 8.9541 6.34329 8.9541 8V9H14.9541V8C14.9541 6.34329 13.6108 5.00024 11.9541 5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInputPwIco);
export default __webpack_public_path__ + "static/media/Input_pw_ico.ccf9b908f341b309db7be319ed1ab1b7.svg";
export { ForwardRef as ReactComponent };